var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'flex items-center  highlight',
    _vm.isReady ? 'rounded-xl mr-6 mb-6' : 'rounded-xl mr-6 mb-6',
    _vm.isReady ? 'px-6 py-2 h-24' : 'px-4 py-5 h-24' ],style:(_vm.pickupScreenFirstBorder +
    "\n      border-width: 2px !important;\n      --highlightColor: " + (_vm.customThemeVariables['pickup-screen-first--border']) + "\n    ")},[(!_vm.menu.is_collection_code_enabled)?_c('span',{staticClass:"flex"},[_c('span',{class:[
      'font-light',
      _vm.isReady ? 'text-2xl' : 'text-xl',
      _vm.isReady ? 'mr-5' : 'mr-3' ],style:(_vm.pickupScreenFirstOrderNumber)},[_vm._v(" #"+_vm._s(_vm.data["Order"].Id)+" ")]),_c('span',{class:[
      'font-medium leading-7 capitalize whitespace-no-wrap truncate pr-12',
      _vm.isReady
        ? 'text-5xl h-full flex items-center'
        : 'text-4xl h-full flex items-center' ],style:(_vm.pickupScreenFirstNameColor)},[_vm._v(_vm._s(_vm.initials))])]):_vm._e(),(_vm.menu.is_collection_code_enabled)?_c('span',{class:[
      'font-medium leading-7 capitalize whitespace-no-wrap truncate px-6',
      _vm.isReady
        ? 'text-5xl h-full flex items-center'
        : 'text-4xl h-full flex items-center' ],style:(_vm.pickupScreenFirstNameColor)},[_vm._v(_vm._s(_vm.data["Order"].CollectionCode)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }